import { render } from "./side-img-skeleton.vue?vue&type=template&id=2d442740&scoped=true"
import script from "./side-img-skeleton.vue?vue&type=script&lang=js"
export * from "./side-img-skeleton.vue?vue&type=script&lang=js"

import "./side-img-skeleton.vue?vue&type=style&index=0&id=2d442740&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d442740"]])

export default __exports__